var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tasks-container"},[_c('task-list',{attrs:{"claimId":_vm.claim.claim_id,"screen":true,"issues":_vm.issues}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }